// extracted by mini-css-extract-plugin
module.exports = {"container":"BoundedPropertySlider_container__dqdS3","slider":"BoundedPropertySlider_slider__4uWHu","number-field":"BoundedPropertySlider_number-field__ZKwbL"};